import React, { useEffect, useRef, useState } from 'react'
import { useIntl,getLocale } from 'umi';
import * as echarts from 'echarts';
import { formatNum, formatNumOld, formatPercentNum } from "@/pages/dashboard/utils/utils";
import { getMonetUnit } from '../../utils/moneyUnit';


const MeCharts = (props) => {
  const {
    xTitle,
    yTitle,
    height,
    chartData
  } = props
  const chartRef = useRef(null)
  const { formatMessage } = useIntl()
  const isEn = getLocale() === 'en-US'
  useEffect(() => {
    if (chartRef) {
      let timeMentionsBarRef
      timeMentionsBarRef = echarts.init(chartRef.current, null, { renderer: 'canvas' })

      const option = {
        tooltip: {
          show: true,
          borderWidth: 0,
          trigger: 'axis',
          padding: 14 ,
          textStyle: {
            fontSize: 12,
            lineHeight: 18
          },
          backgroundColor :'#262832',
          formatter: (param) => {
            const { value, name, data } = param[0]
            const [xValue, yValue] = value
            const oneText = data?.itemStyle?.opacity ? `${formatMessage({id:'competitor_insight_competitive_comparison_module1_x_previous'})}${isEn?' ':''}${xTitle}` : xTitle
            const twoText = data?.itemStyle?.opacity ? `${formatMessage({id:'competitor_insight_competitive_comparison_module1_x_previous'})}${isEn?' ':''}${yTitle}` : yTitle
            return `
              <div style="display:flex;justify-content:space-between;background: #262832;opacity: 0.95">
                <div style="margin-right:20px;">
                  <p style="color:#EBECF1;font-size: 12px;">${name}</p>
                  <p style="color:#EBECF1;font-size: 12px;margin:7px 0 ">${oneText}</p>
                  <p style="color:#EBECF1;font-size: 12px;">${twoText}</p>
                </div>

                <div>
                  <p style="opacity:0;">1</p>
                  <p style="font-weight: 700;text-align:right;font-size: 14px;color:#EBECF1;margin:8px 0">${xValue === '' ? '-' : formatNum(xValue,false,true)}</p>
                  <p style="font-weight: 700;text-align:right;font-size: 14px;color:#EBECF1">${yTitle === formatMessage({id: 'competitor_insight_competitive_comparison_module2_y_lable'}) ? (!yValue ? '-' : formatPercentNum(yValue, 2)) : (yValue === '' ? '-' : formatNum(yValue.toFixed(4)))}</p>
                </div>
              </div>
            `
          }
        },
        grid: {
          x: '10px',
          y: '30px',
          x2: '50px',
          y2: '10px',
          containLabel: true
        },
        xAxis: {
          name: xTitle,
          nameTextStyle: {
            color: 'rgba(0,0,0,0.65)',
            // align: 'left',
            // padding: [6, 0, 0, 4],
            // verticalAlign: 'top',
          },
          // nameLocation: 'center',
          axisLabel: {
            formatter: (value) => {
              if (!value) return ''
              return formatNumOld(value)
            },
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(0,0,0,0.45)',
            },
          },
          splitLine: {
            show: false,
            lineStyle: {

              type: 'dashed',
            }
          },
        },
        yAxis: {
          name: yTitle === formatMessage({id: 'competitor_insight_competitive_comparison_module2_y_lable'}) ? yTitle : yTitle + `(${getMonetUnit()})`,
          nameTextStyle: {
            color: 'rgba(0,0,0,0.65)',
            // align: 'right',
            padding: yTitle === formatMessage({id: 'competitor_insight_competitive_comparison_module2_y_lable'}) ? [0, 45, 0, 0] : null,
            // verticalAlign: 'bottom'
          },
          axisLabel: {
            formatter: (v) => {
              return yTitle === formatMessage({id: 'competitor_insight_competitive_comparison_module2_y_lable'}) ? formatPercentNum(v, 0) : formatNumOld(v)
            }
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: 'rgba(0,0,0,0.45)',

            },

          },

          axisTick: {
            show: false
          },
          splitLine: {
            // show: false,
            interval: 2,
            lineStyle: {
              interval: 2,
              type: 'dashed',

            }
          },
        },
        // animation:false,
        series: [
          {
            type: 'scatter',
            data: chartData
          }
        ]
      }
      timeMentionsBarRef.setOption(option, true)
      window.addEventListener('resize', function () {
        timeMentionsBarRef.resize();
      })
      // setChart(timeMentionsBarRef);
    }
  }, [chartData])
  return (
    <div ref={chartRef} style={{ height: height + 'px', width: '100%' }}></div>
  )
}

export default MeCharts
